import React, { useState } from "react";
import styles from "./OngoingTask.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { DateInput, Dropdown } from "../../../../components";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import TopTabComponent from "../../../../components/TopTabComponent/TopTabComponent";
import HeadingComponent from "../../../../components/HeadingComponent/HeadingComponent";
import StepsComponent from "../../../../components/StepsComponent/StepsComponent";
import MultipleCheck from "../../../../components/MultipleCheck/MultipleCheck";

import {
  SearchInput,
  SubmitButton,
  TextComponent,
  Modal,
  InputField,
} from "../../../../components";
import IconSidebar from "../IconSidebar/IconSidebar";
import CheckBox from "../../../../components/Checkbox/CheckBox";
import { ReactComponent as TabIcon } from "../../../../assets/images/tabIcon.svg";
import { ReactComponent as StarIcon } from "../../../../assets/images/startIcon.svg";
import { ReactComponent as ActionIcon } from "../../../../assets/images/actionicon.svg";
import { ReactComponent as Checkboxes } from "../../../../assets/images/Checkboxes.svg";
import { ReactComponent as UncheckedIcon } from "../../../../assets/images/UncheckedIcon.svg";
import { ReactComponent as UploadIcon } from "../../../../assets/images/file-add.svg";
import { ReactComponent as FlagCircle } from "../../../../assets/images/flagCircle.svg";
import { ReactComponent as Crossiant } from "../../../../assets/images/QrCrossiant.svg";
import { Table, Tag, Select, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { IoClose } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdEdit, MdOutlineDateRange } from "react-icons/md";
import { IoIosArrowBack, IoIosSave } from "react-icons/io";
import ModalLeft from "../../../../components/ModalLeft/ModalLeft";
import { ReactComponent as CloseIcon } from "../../../../assets/images/closeIcon.svg";
import { ReactComponent as MinusIcon } from "../../../../assets/images/minusIcon.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/images/plusIcon.svg";
import QcImage from "../../../../assets/images/staticImages/QcImage.png"
import { IoMdClose } from "react-icons/io";
import { ReactComponent as BackIcon } from "../../../../assets/images/textBackIcon.svg";


const MachineUsedByOptions = [
  { id: 1, name: "John Smit" },
  { id: 2, name: "Emily Davis" },
  { id: 3, name: "Michael Brown" },
  { id: 4, name: "Sarah Johnson" },
  { id: 5, name: "Laura Thompson" },
  { id: 6, name: "James Miller" },
];

const categories = [
  {
    value: "Ingredient",
    role: "Ingredient",
    id: 1,
  },
  {
    value: "Ingredient 2",
    role: "Ingredient 2",
    id: 2,
  },
  {
    value: "Ingredient 3",
    role: "Ingredient 3",
    id: 3,
  },
];

const DropDownOptions = [
  {
    value: "Order Update	",
    id: 1,
  },
  {
    value: "Inventory",
    id: 2,
  },
];

const options = [
  { id: 1, name: "Mixing", Icon: <TabIcon width={16} height={16} /> },
  { id: 2, name: "Make-Up", Icon: <TabIcon width={16} height={16} /> },
  { id: 3, name: "Proofing", Icon: <TabIcon width={16} height={16} /> },
  { id: 4, name: "Chill", Icon: <TabIcon width={16} height={16} /> },
];

const FlagTaskDetList = (flag) => [
  {
    id: 1,
    label: "What kind of issue are you facing?",
    Value: "Missing Ingredient",
  },
  {
    id: 2,
    label: " Description",
    Value:
      "Water line pressure is low — can’t reach correct temp. Grain mix not soaked in time.",
  },
  {
    id: 1,
    label: "Date & Time ",
    Value: "9/2/2025 4:45 PM",
  },
  {
    id: 1,
    label: "Attach Photo",
    Value: (
      <div>
        <Crossiant />
      </div>
    ),
  },
  {
    id: 1,
    label: "Status",
    Value:
      flag?.Status === "Approved"
        ? "Approved"
        : flag?.Status === "Rejected"
          ? "Rejected"
          : flag?.Status === "Advised"
            ? "Advised | Stock has been adjusted"
            : "-",
  },
];

const { Option } = Select;

const OngoingTask = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const [lot, setLot] = useState(false);
  const steps = ["Scaling", "Station Process"];
  const [selectedBtn, setselectedBtn] = useState("btn1");
  const current = Number(new URLSearchParams(search).get("step")) || 0;
  const [imagePreview, setImagePreview] = useState(null);
  const [imagesPreview, setImagesPreview] = useState([]);
  const [focusedTab, setFocusedTab] = useState(options[0]);
  const [ActionType, setActionType] = useState({
    value: "Order Update	",
    id: 1,
  });
  const [finalize, setFinalize] = useState(false);
  const [actualInput, setActualInput] = useState("");
  const [actualInputOne, setActualInputOne] = useState("");
  const [actualInputTwo, setActualInputTwo] = useState("");
  const [actualInputThree, setActualInputThree] = useState("");
  const [confirmOrder, setConfirmOrder] = useState(false);
  const [printLabel, setPrintLabel] = useState(false);
  const [printLabelModal, setPrintLabelModal] = useState(false);
  const [flagTaskModal, setFlagTaskModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [reportDesc, setReportDesc] = useState("");
  const [failTaskModal, setFailTaskModal] = useState(false);
  const [failTask, setFailTask] = useState("");
  const [passwordModal, setPasswordModal] = useState("");
  const [password, setPassword] = useState("");
  const [addModal, setaddModal] = useState(false);
  const [quantity, setquantity] = useState(2);
  const [name, setname] = useState("");
  const [reason, setreason] = useState("");
  const [category, setcategory] = useState("");
  const [reportDrop, setReportDrop] = useState({
    value: "Order Update	",
    id: 1,
  });
  const [fields, setFields] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editLabel, setEditLabel] = useState("");
  const [flagTaskDetailModal, setFlagTaskDetailModal] = useState("")
  const [prodName, setProdName] = useState("")
  const [batchNum, setBatchNum] = useState("")
  const [prodDate, setProdDate] = useState("")
  const [prodExpDate, setProdExpDate] = useState("")
  const [station, setStation] = useState("")
  const [prodQuantity, setProdQuantity] = useState("")
  const [itemName, setItemName] = useState("")
  const [lotNo, setLotNo] = useState("")
  const [taskId, setTaskId] = useState("")
  const [selectedFlag, setSelectedFlag] = useState(null);
  const details = FlagTaskDetList(selectedFlag);



  const basicInfoData = {
    "Process Name": "Bulk Fermentation- Pre-Ferments",
    "Process Time": "30 Min",
  };
  const methodData = {
    "Machine Used": "Brick Oven",
    Parameters: "",
    Time: "2:30 Pm",
    Temperature: "25°C",
  };
  const additionalData = {
    Time: "2:30 Pm",
    Temperature: "25°C",
  };
  const instructionsData = {
    "01": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "02": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "03": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "04": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "05": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "06": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "07": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "08": "prep Cambro with canola oil, 11.3Kg max dough per container",
    "09": "prep Cambro with canola oil, 11.3Kg max dough per container",
  };
  const finishedData = [
    {
      label: "Bake Temperature (Fahrenheit)",
      type: "Numeric",
      value: "45",
    },
    {
      label: "Time (minutes)",
      type: "Numeric",
      value: "20",
    },
  ];
  const onNext = () => {
    if (current < steps.length - 1) {
      navigate(`?step=${current + 1}`);
    }
  };

  const onPrev = () => {
    if (current > 0) {
      navigate(`?step=${current - 1}`);
    }
  };

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const onChangeImg = (e) => {
    const file = e.target.files[0];
    if (file) {
      const previewURL = URL.createObjectURL(file);
      setImagePreview(previewURL);
    }
  };

  const onChangeImages = (e) => {
    const files = Array.from(e.target.files);

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setImagesPreview((prev) => [...prev, ...newImages]);
  };

  const removeImage = (index) => {
    setImagesPreview((prev) => prev.filter((_, i) => i !== index));
  };

  const columns = [
    {
      title: "Ingredients",
      dataIndex: "Ingredients",
      key: "Ingredients",
      render: (text, record) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
          {(record.ComponentName === "Pie Crust Dough" ||
            record.ComponentName === "Choux Pastry Shells" ||
            record.ComponentName === "Brownie Base" ||
            record.ComponentName === "Cookie Dough" ||
            record.Ingredients === "butter, unsalted") && (
              <div className={styles.ingredientCellIconsDiv}>
                <Tooltip title={"allergy"}>
                  <ActionIcon className={styles.icons} />
                </Tooltip>
                <StarIcon className={styles.icons} />
              </div>
            )}
        </div>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },
    {
      title: "Baker’s %",
      key: "TotalBaker",
      dataIndex: "TotalBaker",
    },
    {
      title: "Available",
      key: "Available",
      dataIndex: "Available",
      // render: (text, record) => {
      //   return (
      //  <Checkboxes />
      // <div style={{ justifyContent: "center" }}>
      // <CheckBox onClick={onChange}></CheckBox>
      // </div>
      // );
      // },
    },
    {
      title: "Lot Tracking",
      key: "action",
      dataIndex: "Button",
      render: (text, record) => record.Button,
    },
  ];

  const data = [
    {
      Ingredients: "Pie Crust Dough",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />

        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "Choux Pastry Shells",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "Pie Crust Dough",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "Choux Pastry Shells",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },

    {
      Ingredients: "Pie Crust Dough",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
    {
      Ingredients: "butter, unsalted",
      Quantity: "0.81",
      TotalBaker: "0.81 ",
      ShelfLife: "180 days",
      Available: (
        <div className={styles.checkboxContainer}>
          <Checkboxes />
        </div>
      ),
      Button: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.actionBtn}
          onClick={() => setLot(true)}
        />
      ),
    },
  ];

  const finalColumns = [
    {
      title: "Parameter",
      dataIndex: "Parameter",
      key: "Parameter",
    },
    {
      title: "Expected",
      key: "Expected",
      dataIndex: "Expected",
    },
    {
      title: "Actual",
      key: "Actual",
      dataIndex: "Actual",
    },
  ];

  const finalData = [
    {
      Parameter: "Proof Time",
      Expected: "15 min",
      Actual: (
        <div>
          <InputField
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
              maxWidth: "150px",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={actualInputOne}
            onChange={(e) => setActualInputOne(e.target.value)}
          />
        </div>
      ),
    },

    {
      Parameter: "Pieces Ready",
      Expected: "16",
      Actual: (
        <div>
          <InputField
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
              maxWidth: "150px",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={actualInputTwo}
            onChange={(e) => setActualInputTwo(e.target.value)}
          />
        </div>
      ),
    },
    {
      Parameter: "Waste Quantity",
      Expected: "00",
      Actual: (
        <div>
          <InputField
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
              maxWidth: "150px",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={actualInputThree}
            onChange={(e) => setActualInputThree(e.target.value)}
          />
        </div>
      ),
    },
  ];

  const flagColumns = [
    {
      title: "Task",
      dataIndex: "Task",
      key: "Task",
    },
    {
      title: "Status",
      key: "Status",
      dataIndex: "Status",
    },
    {
      title: "Action",
      render: (_, record) => (
        <SubmitButton
          title="View"
          primary
          btnClass={styles.flagBtn}
          onClick={() => {
            setSelectedFlag(record);
            setFlagTaskDetailModal(true);
            setFlagTaskModal(false);
          }}
        />
      ),
    },
  ];

  const flagData = [
    {
      Task: "Faulty Machine",
      Status: "Approved",
      Action: <SubmitButton title={"View"} primary btnClass={styles.flagBtn} />,
    },
    {
      Task: "Spoiled Ingredients",
      Status: "Rejected",
      Action: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.flagBtn}
        // onClick={() => setLot(true)}
        />
      ),
    },
    {
      Task: "Damaged Goods",
      Status: "Advised",
      Action: (
        <SubmitButton
          title={"View"}
          primary
          btnClass={styles.flagBtn}
        // onClick={() => setLot(true)}
        />
      ),
    },
  ];

  const reasons = [
    {
      value: "Burnt",
      role: "Burnt",
      id: 1,
    },
  ];

  const [modalArr, setModalArr] = useState([
    "C#  123",
    "C#  124",
    "C#  123",
    "C#  125",
  ]);

  const addField = () => {
    const newField = {
      id: Date.now(),
      label: "New Field", // default name
      value: "",
    };
    setFields([...fields, newField]);
  };

  const removeField = (id) => {
    setFields(fields.filter((f) => f.id !== id));
  };

  const handleChange = (id, newValue) => {
    setFields(fields.map((f) => (f.id === id ? { ...f, value: newValue } : f)));
  };

  const handleEdit = (field) => {
    setEditingId(field.id);
    setEditLabel(field.label);
  };

  const saveEdit = (id) => {
    setFields(
      fields.map((f) => (f.id === id ? { ...f, label: editLabel } : f))
    );
    setEditingId(null);
    setEditLabel("");
  };

  return (
    <div>
      <div className={styles.mainCont}>
        <div className={styles.HeadingDiv}>
          <div className={styles.headingDiv}>
            <div className={styles.Row}>
              <TextComponent
                backIcon={true}
                className={styles.Heading}
                text={"Choc Chip Cookie "}
              />
              <div className={styles.taskId}>
                <TextComponent text={"# 153485"} className={styles.idText} />
              </div>
            </div>
            <div className={styles.ButtonDiv}>
              <SubmitButton
                btnContainerClass={styles.btnContainer}
                btnClass={styles.btnClass}
                title={"Flag Task"}
                onClick={() => {
                  setFlagTaskModal(true);
                }}
              />
              <SubmitButton
                btnContainerClass={styles.btnContainer}
                btnClass={styles.btnClass}
                primary
                title={"Log Waste"}
                onClick={() => {
                  setPasswordModal(true);
                }}
              />
              <SubmitButton
                btnContainerClass={styles.btnContainer}
                btnClass={styles.btnClass}
                secondary
                title={"Fail Task"}
                onClick={() => {
                  setFailTaskModal(true);
                }}
              />
            </div>
          </div>
          <div className={styles.stepsComp}>
            <StepsComponent
              steps={steps}
              currentStepIndex={current}
              onPrev={onPrev}
              onNext={onNext}
            />
          </div>
          {current === 0 && (
            <div className={styles.TableDiv}>
              <Table
                scroll={{ x: true }}
                columns={columns}
                dataSource={data}
                pagination={false}
                rowKey="No"
                rowClassName={styles.tableRow}
                footer={() => (
                  <div className={styles.tableFooter}>
                    <div className={styles.footerRow}>
                      <div className={styles.footerLabel}>
                        <TextComponent
                          text={"Total Quantity"}
                          className={styles.footerText}
                        />
                      </div>
                      <div className={styles.footerValue}>
                        <TextComponent
                          text={"332.36"}
                          className={styles.footerText}
                        />
                      </div>
                      <div className={styles.footerValue}>
                        <TextComponent
                          text={"332.36"}
                          className={styles.footerText}
                        />
                      </div>
                    </div>
                  </div>
                )}
              />
            </div>
          )}
          {current === 1 && (
            <div>
              <div className={styles.buttonsDiv}>
                <div className={styles.HeaderRow}>
                  <TextComponent
                    className={styles.Heading}
                    text={"Sourdough Dough Mix (MIX-SD-BASE)"}
                  />
                </div>
                <SubmitButton
                  title={"Process 1"}
                  primary={selectedBtn === "btn1" ? true : false}
                  onClick={() => setselectedBtn("btn1")}
                  btnContainerClass={styles.stageBtn}
                  btnClass={styles.btn}
                  textClass={styles.finishedBtnTxt}
                />
                <SubmitButton
                  title={"Process 2"}
                  primary={selectedBtn === "btn2" ? true : false}
                  onClick={() => setselectedBtn("btn2")}
                  btnContainerClass={styles.stageBtn}
                  btnClass={styles.btn}
                  textClass={styles.finishedBtnTxt}
                />

                {/* <FlagCircle style={{ width: "40px", cursor: "pointer", marginBottom: 14 }} onClick={() => { setFlagTaskModal(true) }} /> */}
              </div>

              <div className={styles.parentCont}>
                {selectedBtn === "btn1" && (
                  <>
                    <div className={styles.leftCont}>
                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Basic Information"}
                        />
                        <div className={styles.itemsList}>
                          {Object.entries(basicInfoData).map(
                            ([label, value]) => {
                              const formattedLabel = label.replace(/_/g, " ");
                              return (
                                <div className={styles.row}>
                                  <TextComponent
                                    className={styles.label}
                                    text={`${formattedLabel} :`}
                                  />
                                  <TextComponent
                                    className={styles.value}
                                    text={value || "-"}
                                  />
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Method"}
                        />
                        <div className={styles.row}>
                          <TextComponent
                            className={styles.label}
                            text={"Machine Used "}
                          />
                          <TextComponent
                            className={styles.value}
                            text={"Brick Oven"}
                          />
                        </div>
                        <div style={{ marginTop: 2 }}>
                          <TextComponent
                            className={styles.label}
                            text={"Machine Used By"}
                          />
                          <MultipleCheck
                            label={"John Smit"}
                            data={MachineUsedByOptions}
                            displayCheckBox
                            rangePickerInput={styles.rangePickerInput}
                            rangePickerText={styles.rangePickerText}
                          />
                        </div>
                      </div>

                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Parameter"}
                        />
                        <div className={styles.itemsList}>
                          {Object.entries(additionalData).map(
                            ([label, value]) => {
                              const formattedLabel = label.replace(/_/g, " ");
                              return (
                                <div className={styles.row}>
                                  <TextComponent
                                    className={styles.label}
                                    text={`${formattedLabel} :`}
                                  />
                                  <TextComponent
                                    className={styles.value}
                                    text={value || "-"}
                                  />
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>

                    <div className={styles.rightCont}>
                      <div className={styles.box}>
                        <TextComponent
                          className={styles.Heading}
                          text={"Instructions"}
                        />
                        <div className={styles.itemsList}>
                          {Object.entries(instructionsData).map(
                            ([label, value]) => {
                              const formattedLabel = label.replace(/_/g, " ");
                              return (
                                <div className={styles.InsCont}>
                                  <div className={styles.inLineRow}>
                                    <TextComponent
                                      className={styles.instructionslabel}
                                      text={`${formattedLabel} `}
                                    />
                                    <TextComponent
                                      className={styles.instructionsvalue}
                                      text={value || "-"}
                                    />
                                  </div>
                                  <div>
                                    <CheckBox onClick={onChange}></CheckBox>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>

                    <div className={styles.thirdCont}>
                      <IconSidebar />
                    </div>
                  </>
                )}
              </div>
              <div className={styles.parentCont}>
                {selectedBtn === "btn2" && (
                  <>
                    <div className={styles.parentCont2}>
                      <div className={styles.childCont}>
                        <div className={styles.leftCont}>
                          <div className={styles.box}>
                            <TextComponent
                              className={styles.Heading}
                              text={"Basic Information"}
                            />
                            <div className={styles.itemsList}>
                              {Object.entries(basicInfoData).map(
                                ([label, value]) => {
                                  const formattedLabel = label.replace(
                                    /_/g,
                                    " "
                                  );
                                  return (
                                    <div className={styles.row}>
                                      <TextComponent
                                        className={styles.label}
                                        text={`${formattedLabel} :`}
                                      />
                                      <TextComponent
                                        className={styles.value}
                                        text={value || "-"}
                                      />
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                          <div className={styles.box}>
                            <TextComponent
                              className={styles.Heading}
                              text={"Method"}
                            />
                            <div className={styles.row}>
                              <TextComponent
                                className={styles.label}
                                text={"Machine Used "}
                              />
                              <TextComponent
                                className={styles.value}
                                text={"Brick Oven"}
                              />
                            </div>
                            <div style={{ marginTop: 2 }}>
                              <TextComponent
                                className={styles.label}
                                text={"Machine Used By"}
                              />
                              <MultipleCheck
                                label={"John Smit"}
                                data={MachineUsedByOptions}
                                displayCheckBox
                                rangePickerInput={styles.rangePickerInput}
                                rangePickerText={styles.rangePickerText}
                              />
                            </div>
                          </div>

                          <div className={styles.box}>
                            <TextComponent
                              className={styles.Heading}
                              text={"Parameter"}
                            />
                            <div className={styles.itemsList}>
                              {Object.entries(additionalData).map(
                                ([label, value]) => {
                                  const formattedLabel = label.replace(
                                    /_/g,
                                    " "
                                  );
                                  return (
                                    <div className={styles.row}>
                                      <TextComponent
                                        className={styles.label}
                                        text={`${formattedLabel} :`}
                                      />
                                      <TextComponent
                                        className={styles.value}
                                        text={value || "-"}
                                      />
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                          <div className={styles.box}>
                            <TextComponent
                              className={styles.Heading}
                              text="QC Check"
                            />
                            {/* <div className={styles.upload}>
                              <label className={styles.uploadLabel}>
                                <input
                                  type="file"
                                  accept="image/*"
                                  className={styles.fileInput}
                                  onChange={onChangeImg}
                                />
                                <UploadIcon className={styles.icon} />
                                <span className={styles.text}>Upload</span>
                              </label>
                            </div> */}

                            {/* {imagePreview && (
                              <div className={styles.previewContainer}>
                                <img
                                  src={imagePreview}
                                  alt="Preview"
                                  className={styles.previewImage}
                                />
                              </div>
                            )} */}
                            <div className={styles.previewContainer}>
                              <img
                                src={QcImage}
                                alt="Preview"
                                className={styles.previewImage}
                              />
                            </div>
                          </div>
                        </div>
                        <div className={styles.rightCont}>
                          <div className={styles.box}>
                            <TextComponent
                              className={styles.Heading}
                              text={"Instructions"}
                            />
                            <div className={styles.itemsList}>
                              {Object.entries(instructionsData).map(
                                ([label, value]) => {
                                  const formattedLabel = label.replace(
                                    /_/g,
                                    " "
                                  );
                                  return (
                                    <div className={styles.InsCont}>
                                      <div className={styles.inLineRow}>
                                        <TextComponent
                                          className={styles.instructionslabel}
                                          text={`${formattedLabel} `}
                                        />
                                        <TextComponent
                                          className={styles.instructionsvalue}
                                          text={value || "-"}
                                        />
                                      </div>
                                      <div>
                                        <CheckBox onClick={onChange}></CheckBox>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        {!printLabel ? (
                          <SubmitButton
                            title={"Finalize"}
                            primary
                            onClick={() => {
                              setFinalize(true);
                            }}
                          />
                        ) : (
                          <SubmitButton
                            title={"Print Label"}
                            primary
                            onClick={() => {
                              setPrintLabelModal(true);
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div className={styles.thirdCont}>
                      <IconSidebar />
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ////////////////////////FLAG TASK DETAIL  modal ///////////////// */}
      <Modal
        open={flagTaskDetailModal}
        onCancel={() => {
          setFlagTaskDetailModal(false);
        }}
        onClickOkButton={() => {
          setFlagTaskDetailModal(false);
        }}
        className={styles.modalCont}
        width={"400px"}
        buttonTitle={
          selectedFlag?.Status === "Advised" ? "Mark as Done" : null
        }
        onBtnPress={() => setFlagTaskDetailModal(false)}
        btnStyle={{ marginTop: "12px" }}
      >
        <div className={styles.backIcon}>
          <BackIcon width={25} height={25} onClick={() => {
            setFlagTaskDetailModal(false);
            setFlagTaskModal(true);
          }} />
        </div>
        <div style={{ width: "100%", marginTop: "12px" }}>
          {details.map((item) => (
            <div key={item.id}>
              <TextComponent
                className={styles.FlagTasklabel}
                text={item.label}
              />
              <div className={styles.FlagTaskvalue}>{item.Value}</div>
            </div>
          ))}
        </div>
      </Modal>

      {/* ////////////////////////FailTask modal ///////////////// */}
      <Modal
        open={failTaskModal}
        onCancel={() => {
          setFailTaskModal(false);
        }}
        onClickOkButton={() => {
          navigate("/SupervisorRecipeProduction")
          setFailTaskModal(false)
        }}
        className={styles.modalCont}
        title={"Fail Task?"}
        headingClass={styles.modalHeading}
        width={"400px"}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setFailTaskModal(false)}
        type={"password"}
      >
        <TextComponent
          text={"Failing this task will result in the following:"}
        />
        <ul>
          <li>All items involved in producing this product will be wasted.</li>
          <li>
            The product’s journey will be marked as failed at this station.
          </li>
          <li>A new order will need to be created to recreate the product.</li>
        </ul>
        <InputField
          label={"Enter Supervisor Password"}
          placeholder={"12*******"}
          innerInput={{ width: "" }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>

      {/* ////////////////////////password modal ///////////////// */}
      <Modal
        open={passwordModal}
        onCancel={() => {
          setPasswordModal(false);
        }}
        onClickOkButton={() => {
          setPasswordModal(false);
          setaddModal(true);
        }}
        className={styles.modalCont}
        title={"Enter Supervisor Password"}
        headingClass={styles.modalHeading}
        width={"400px"}
        // btnStyle={{ width: "200px", }}
        twoButton
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
        onClickCancelButton={() => setPasswordModal(false)}
        type={"password"}
      // onBtnPress={() => setLimitExceedsModal(false)}
      >
        <InputField
          placeholder={"12*******"}
          innerInput={{ width: "" }}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </Modal>

      {/* ////////////////////////// Waste Log//////////////////////////////// */}
      <ModalLeft
        open={addModal}
        onCancel={() => {
          setaddModal(false);
        }}
        className={styles.modalCont}
        // title={"Add Waste Entry"}
        title={"Add Waste Entry"}
        buttonTitle={"save"}
        onBtnPress={() => setaddModal(false)}
        btnStyle={{ marginTop: "20px", width: "50%" }}
      >
        <div className={styles.modalContent}>
          {/* <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Task ID"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="#001"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={taskId}
                onChange={(e) => setTaskId(e.target.value)}
              />
            </div>
          </div> */}
          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Category"} />
            <div className={styles.search_div}>
              <Dropdown
                value={category}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={categories}
                onChange={(e) => setcategory(e)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Item Name"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="Chocolate Muffin"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={itemName}
                onChange={(e) => setItemName(e.target.value)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Quantity "}
            />
            <div className={styles.itemControls}>
              <MinusIcon
                className={styles.Controls}
                onClick={() => {
                  quantity >= 1 && setquantity(quantity - 1);
                }}
              />
              <TextComponent className={styles.ControlsText} text={quantity} />
              <PlusIcon
                className={styles.Controls}
                onClick={() => setquantity(quantity + 1)}
              />
            </div>
          </div>

          <div className={styles.itemRow}>
            <TextComponent className={styles.itemName} text={"Lot No"} />
            <div className={styles.search_div}>
              <SearchInput
                placeholder="#123"
                rightIcon={<SearchOutlined />}
                className={styles.searchInput}
                value={lotNo}
                onChange={(e) => setLotNo(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.itemRow}>
            <TextComponent
              className={styles.itemName}
              text={"Reason for Waste"}
            />
            <div className={styles.search_div}>
              <Dropdown
                value={reason}
                inputStyle={{
                  backgroundColor: "var(--bg-grey)",
                }}
                options={reasons}
                onChange={(e) => setreason(e)}
              />
            </div>
          </div>
        </div>
      </ModalLeft>
      {/* ////////////////////////// Lot Tracking //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={lot}
        onCancel={() => {
          setLot(false);
        }}
        onClickOkButton={() => {
          setLot(false);
        }}
        className={styles.Modal}
        buttonTitle={"Confirm"}
        onBtnPress={() => setLot(false)}
      >
        <HeadingComponent text={"Heavy Cream"} className={styles.modalHead} />
        <TextComponent text={"Lot #"} className={styles.lotNo} />
        <SearchInput
          rightIcon={<SearchOutlined />}
          placeholder={"Search Lot"}
        />
        <div className={styles.modalArrDiv}>
          {modalArr?.map((item, index) => (
            <div className={styles.modalArrItem}>
              <TextComponent text={item} />
              <IoClose
                size={20}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  let arr = [...modalArr];
                  const result = arr.filter((_, i) => i !== index);
                  setModalArr(result);
                }}
              />
            </div>
          ))}
        </div>
      </Modal>

      {/* ////////////////////////// Finalize //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={finalize}
        onCancel={() => {
          setFinalize(false);
        }}
        onBtnPress={() => {
          setConfirmOrder(true);
          setFinalize(false);
        }}
        className={styles.Modal}
        buttonTitle={"Complete Task"}
      >
        <HeadingComponent text={"Finalize"} className={styles.modalHead} />
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={finalColumns}
            dataSource={finalData}
            pagination={false}
          />
        </div>
      </Modal>

      {/* ////////////////////////// Confirm Order //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={confirmOrder}
        onCancel={() => {
          setConfirmOrder(false);
        }}
        onClickOkButton={() => {
          setConfirmOrder(false);
          setPrintLabel(true);
        }}
        onClickCancelButton={() => {
          setConfirmOrder(false);
        }}
        twoButton
        className={styles.Modal}
        onBtnPress={() => setConfirmOrder(false)}
        okBtnTitle={"Confirm"}
        cancelBtnTitle={"Cancel"}
      >
        <HeadingComponent
          text={"Complete Task"}
          className={styles.modalHead}
        />
        <TextComponent
          text={
            "Completing this order will finalize the task and cannot be undone. Any abnormal entries will be automatically flagged and sent to the Supervisor for review."
          }
        />
      </Modal>

      {/* ////////////////////////// PrintLabel//////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={printLabelModal}
        onCancel={() => {
          setPrintLabelModal(false);
        }}
        onClickOkButton={() => {
          setPrintLabelModal(false);
        }}
        className={styles.Modal}
        title={"Print Label"}
        onBtnPress={() => setPrintLabelModal(false)}
        buttonTitle={"Print"}
      >
        <div className={styles.modalInput}>
          <InputField
            label={"Product Name "}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={prodName}
            onChange={(e) => setProdName(e.target.value)}
          />

          <InputField
            label={"Batch Number"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={batchNum}
            onChange={(e) => setBatchNum(e.target.value)}
          />
        </div>

        <div className={styles.modalInput}>
          <InputField
            label={"Production Date/Time"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={prodDate}
            onChange={(e) => setProdDate(e.target.value)}
          />

          <InputField
            label={"Expiration Date"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={prodExpDate}
            onChange={(e) => setProdExpDate(e.target.value)}
          />
        </div>
        <div className={styles.modalInput}>
          <InputField
            label={"Station"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={station}
            onChange={(e) => setStation(e.target.value)}
          />

          <InputField
            label={"Quantity"}
            placeholder={"Enter here…"}
            inputStyle={{
              backgroundColor: "#F7F8F9",
              border: "1.5px solid #E8ECF4",
            }}
            innerInput={{ backgroundColor: "#F7F8F9" }}
            className={styles.inputNew}
            value={prodQuantity}
            onChange={(e) => setProdQuantity(e.target.value)}
          />
        </div>


        <div className={styles.addFieldCont}>
          {fields.map((field) => (
            <div key={field.id} className={styles.fieldContainer}>
              <div className={styles.fieldHeader}>
                {editingId === field.id ? (
                  <InputField
                    placeholder="Enter here…"
                    inputStyle={{
                      backgroundColor: "#F7F8F9",
                      border: "1.5px solid #E8ECF4",
                    }}
                    innerInput={{ backgroundColor: "#F7F8F9" }}
                    className={styles.editInput}
                    value={editLabel}
                    onChange={(e) => setEditLabel(e.target.value)}
                    autoFocus
                  />
                ) : (
                  <TextComponent
                    className={styles.fieldLabel}
                    text={field.label}
                  />
                )}

                <div className={styles.iconGroup}>
                  {editingId === field.id ? (
                    <IoIosSave onClick={() => saveEdit(field.id)} />
                  ) : (
                    <>
                      <RiDeleteBin6Line onClick={() => removeField(field.id)} />
                      <MdEdit onClick={() => handleEdit(field)} />
                    </>
                  )}
                </div>
              </div>

              <InputField
                placeholder="Enter here…"
                inputStyle={{
                  backgroundColor: "#F7F8F9",
                  border: "1.5px solid #E8ECF4",
                }}
                innerInput={{ backgroundColor: "#F7F8F9" }}
                className={styles.inputNew}
                value={field.value}
                onChange={(e) => handleChange(field.id, e.target.value)}
              />
            </div>
          ))}

          <SubmitButton
            title="+ Add Field"
            primary
            onClick={addField}
            btnClass={styles.addFieldBtn}
          />
        </div>
      </Modal>

      {/* ////////////////////////// Flag Task //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={flagTaskModal}
        onCancel={() => {
          setFlagTaskModal(false);
        }}
        onBtnPress={() => {
          setReportModal(true);
          setFlagTaskModal(false);
        }}
        className={styles.Modal}
        buttonTitle={"Report A Problem"}
      >
        <HeadingComponent text={"Flagged Tasks"} className={styles.modalHead} />
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={flagColumns}
            dataSource={flagData}
            pagination={false}
          />
        </div>
      </Modal>

      {/* ////////////////////////// Report a Problem //////////////////////////////// */}

      <Modal
        subClassName={styles.modalContentStyle}
        open={reportModal}
        onCancel={() => {
          setReportModal(false);
        }}
        onBtnPress={() => {
          setReportModal(false);
        }}

        className={styles.Modal}
        buttonTitle={"Submit"}
      >
        <div className={styles.backIcon}>
          <BackIcon width={25} height={25} onClick={() => {
            setReportModal(false);
            setFlagTaskModal(true);
          }} />
        </div>
        <HeadingComponent
          text={"Report a Problem"}
          className={styles.modalHead}
        />
        <Dropdown
          label={"What kind of issue are you facing?"}
          placeholder={"Missing Ingredient"}
          value={reportDrop}
          options={DropDownOptions}
          onChange={(e) => setReportDrop(e)}
        />
        <InputField
          label={" Description"}
          placeholder={"Enter here…"}
          inputStyle={{
            backgroundColor: "#F7F8F9",
            border: "1.5px solid #E8ECF4",
          }}
          innerInput={{ backgroundColor: "#F7F8F9" }}
          className={styles.inputNew}
          value={reportDesc}
          onChange={(e) => setReportDesc(e.target.value)}
        />

        <div className={styles.box}>
          <TextComponent className={styles.Heading} text="Attach Photo" />
          <div className={styles.upload}>
            <label className={styles.uploadLabel}>
              <input
                multiple
                type="file"
                accept="image/*"
                className={styles.fileInput}
                onChange={onChangeImages}
              />
              <UploadIcon className={styles.icon} />
              <span className={styles.text}>Upload</span>
            </label>
          </div>
          {/* {imagePreview && (
            <div className={styles.previewContainer}>
              <img
                src={imagePreview}
                alt="Preview"
                className={styles.previewImage}
              />
            </div>
          )} */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 10,
              marginTop: 4,
            }}
          >
            {imagesPreview.map((img, index) => (
              <div key={index} className={styles.previewBox}>
                <img
                  src={img.preview}
                  alt="Preview"
                  className={styles.previewImage}
                />
                <IoMdClose
                  color="white"
                  className={styles.removeBtn}
                  onClick={() => removeImage(index)}
                />
              </div>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default OngoingTask;
